import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Api } from '../../providers/api';
import 'rxjs/add/operator/debounceTime';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-admin-code-recovery',
  templateUrl: './admin-code-recovery.component.html',
  styleUrls: ['./admin-code-recovery.component.css']
})
export class AdminCodeRecoveryComponent implements OnInit {

  constructor(private router: Router,
              private spinner: NgxSpinnerService,
              private api: Api,
              private fb: FormBuilder) {
  }

  private _success = new Subject<string>();
  successMessage: string;
  alertType = 'danger';
  pending = false;

  step = 1;
  storedCode: string;
  storedEmail: string;

  form: FormGroup;

  goToStep(n: number) {
    this.step = n;
    this.successMessage = null;
  }

  verifyCode() {
    if (this.pending) return;
    const emailControl = this.form.get('email');
    const codeControl = this.form.get('code');
    emailControl.markAsTouched();
    codeControl.markAsTouched();
    if (emailControl.invalid) {
      this.alertType = 'danger';
      if (emailControl.errors && emailControl.errors.required) {
        this._success.next('El email es requerido');
      } else {
        this._success.next('Ingrese un email válido');
      }
      return;
    }
    if (codeControl.invalid) {
      this.alertType = 'danger';
      this._success.next('El código debe ser de 6 dígitos numéricos');
      return;
    }
    const email = emailControl.value;
    const code = codeControl.value;
    this.pending = true;
    this.spinner.show();
    this.successMessage = null;
    this.api.verifyAdminCode(email, code).subscribe((res: any) => {
      this.spinner.hide();
      this.pending = false;
      this.storedEmail = email;
      this.storedCode = code;
      this.alertType = 'success';
      this.successMessage = null;
      this.step = 3;
    }, err => {
      console.error('ERROR', err);
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'danger';
      this._success.next(err.error && err.error.message ? err.error.message : 'Error al verificar el código. Intente nuevamente.');
    });
  }

  changePass() {
    if (this.pending) return;
    const emailControl = this.form.get('email');
    const newPassControl = this.form.get('newPass');
    const confirmPassControl = this.form.get('confirmPass');
    const codeControl = this.form.get('code');

    // Email and code are expected from stored values after verify step
    const email = this.storedEmail || emailControl.value;
    const codeValue = this.storedCode || codeControl.value;

    // Sync form values if coming from stored state
    if (this.storedEmail) {
      emailControl.setValue(this.storedEmail);
    }
    if (this.storedCode) {
      codeControl.setValue(this.storedCode);
    }

    // Ensure code is available from storedCode if user navigated via steps
    if (!codeValue || /^[0-9]{6}$/.test(String(codeValue)) === false) {
      codeControl.markAsTouched();
      this.alertType = 'danger';
      this._success.next('El código debe ser de 6 dígitos numéricos');
      this.step = 2;
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailControl.markAsTouched();
      this.alertType = 'danger';
      this._success.next('Ingrese un email válido');
      this.step = 2;
      return;
    }

    // Trigger validations for step 3 (only password fields)
    newPassControl.markAsTouched();
    confirmPassControl.markAsTouched();

    if (newPassControl.invalid || confirmPassControl.invalid) {
      return;
    }

    const newPass = newPassControl.value;
    const confirmPass = confirmPassControl.value;
    if (newPass !== confirmPass) {
      this.alertType = 'danger';
      this._success.next('Las contraseñas no coinciden');
      return;
    }
    const code = String(codeValue);
    this.pending = true;
    this.spinner.show();
    this.api.changePassWithAdminCode(email, code, newPass).subscribe((res: any) => {
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'success';
      this._success.next(res && res.message ? res.message : 'Cambio de Contraseña Exitoso');
      this.form.reset();
      setTimeout(() => this.router.navigate(['login']), 2000);
    }, err => {
      console.error('ERROR', err);
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'danger';
      this._success.next(err.error && err.error.message ? err.error.message : 'Error al cambiar la contraseña. Intente nuevamente.');
    });
  }

  irALogin() {
    this.router.navigate(['login']);
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      if (this.step === 1) {
        this.goToStep(2);
      } else if (this.step === 2) {
        this.verifyCode();
      } else {
        this.changePass();
      }
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      code: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
      newPass: ['', [Validators.required, Validators.minLength(6)]],
      confirmPass: ['', [Validators.required]]
    });

    this._success.subscribe((message) => this.successMessage = message);
    this._success.debounceTime(10000).subscribe(() => this.successMessage = null);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin-code-recovery/admin-code-recovery.component.ts